import React, { useEffect, useState } from 'react';
import KycBreReportInd from './KYCBREReportInd';
import {
  AnalyzeBreDoc,
  getBreAnalyzeData
} from '../../../common/constants/api';
import CircularProgress from '@material-ui/core/CircularProgress';

const KycBreReport = ({ analyzeTheBre, leadId, setShowAnalyseBtn }) => {
  const [loading, setLoading] = useState(false);
  const [breData, setBreData] = useState([]);

  const analyseTheReport = () => {
    setLoading(true);
    AnalyzeBreDoc({ type: 'kyc', leadId: leadId })
      .then(res => {
        setBreData(res || []);
      })
      .catch(error => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const getAnalysedData = () => {
    setLoading(true);
    getBreAnalyzeData(leadId)
      .then(res => {
        setBreData(res);
      })
      .catch(error => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAnalysedData();
  }, []);

  useEffect(() => {
    if (typeof analyzeTheBre === 'boolean') {
      analyseTheReport();
    }
    return () => {
      setShowAnalyseBtn(undefined);
    };
  }, [analyzeTheBre]);
  return (
    <div className="w-full grid grid-cols-1 gap-3 py-4">
      {loading && (
        <div className="table mx-auto mt-2">
          <CircularProgress />
        </div>
      )}
      {!loading && breData?.length == 0 && (
        <div className="w-full text-center items-center text-xs font-open-sans">
          No Analyzed data found!
          <strong
            className="ml-1 cursor-pointer hover:text-blue-200"
            onClick={analyseTheReport}
          >
            Analyze here!
          </strong>
        </div>
      )}
      {!loading &&
        breData?.map(each => (
          <div className="w-full" key={each?.leadId}>
            <KycBreReportInd
              nameData={each?.breAnalysedDataOnKycIdDtoList}
              companyData={each?.breIndustryAnalysedDto}
              applicantType={each?.applicantType}
              gstStatus={each?.breGstAnalysedDto}
              companyGstData={each?.breCompanyNameByGstDto}
            />
          </div>
        ))}
    </div>
  );
};

export default KycBreReport;
